/**
 * Feature version cell.
 *
 * Shows the upstream version a feature ships (the primary `ships` entry) with
 * the package (OCI tag) version as a muted second line. Bundles and features
 * without ship data show the package version. Hover lists every shipped tool;
 * screen readers get the same list as visually hidden text.
 */

import type { ReactElement } from 'react';
import type { Feature } from '../../schemas/admin.schemas';
import { featureVersionInfo, type VersionMarker } from './featureVersionInfo';

const MARKER_TEXT: Record<Exclude<VersionMarker, null>, string> = {
  retired: 'retired',
  'end-of-support': 'end of support',
  unavailable: 'not available',
};

export function FeatureVersion({ feature, selectedLine }: { feature: Feature; selectedLine?: unknown }): ReactElement {
  const { main, pkg, marker, details } = featureVersionInfo(feature, selectedLine);
  return (
    <span tabIndex={0} title={details.join('\n')}>
      {main}
      {marker !== null && (
        <span className="feature-table__subtext feature-version__marker">{MARKER_TEXT[marker]}</span>
      )}
      {pkg !== null && (
        <span className="feature-table__subtext feature-version__pkg">{`pkg ${pkg}`}</span>
      )}
      <span className="sr-only">{details.join('; ')}</span>
    </span>
  );
}
